import { render, staticRenderFns } from "./addStationInfo.vue?vue&type=template&id=552a0448&scoped=true&"
import script from "./addStationInfo.vue?vue&type=script&lang=js&"
export * from "./addStationInfo.vue?vue&type=script&lang=js&"
import style0 from "./addStationInfo.vue?vue&type=style&index=0&id=552a0448&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "552a0448",
  null
  
)

export default component.exports